import { IconButton, InputAdornment, TextField, ThemeProvider } from '@mui/material';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import PropTypes from 'prop-types';
import * as React from 'react';
import { DashboardTheme } from '../globalExports';
import './CustomEmailComponent.css';

export const CustomEmailComponentType = {
  emailValue: PropTypes.string.isRequired,
  handleEmailChange: PropTypes.func.isRequired,
  emailFieldId: PropTypes.string,
  emailFieldName: PropTypes.string,
  isRequired: PropTypes.bool,
  isDisabled: PropTypes.bool,
  autoFocus: PropTypes.bool,
  placeholder: PropTypes.string,
  errorMessage: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  onEnterKeyPress: PropTypes.func,
};

export type CustomEmailComponentPropTypes = PropTypes.InferProps<
  typeof CustomEmailComponentType
>;

const CustomEmailComponent: React.FC<CustomEmailComponentPropTypes> = (props) => {
  const {
    emailValue,
    handleEmailChange,
    emailFieldId,
    emailFieldName,
    isRequired,
    isDisabled,
    autoFocus,
    placeholder,
    errorMessage,
    className,
    label,
    onEnterKeyPress,
  } = props;

  return (
    <ThemeProvider theme={DashboardTheme}>
      <div className={`rms__custom__email__component__container ${className ?? ''}`}>
        <TextField
          variant="outlined"
          focused
          fullWidth
          type="email"
          id={emailFieldId ?? 'rms__custom__email-component'}
          name={emailFieldName ?? 'rms__custom__email-component'}
          label={label ?? 'Email Address *'}
          value={emailValue}
          onChange={(e) => handleEmailChange(e.target.value)}
          required={isRequired ?? false}
          disabled={isDisabled ?? false}
          autoFocus={autoFocus ?? false}
          placeholder={placeholder ?? 'example@email.com'}
          error={!!errorMessage}
          helperText={errorMessage}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onEnterKeyPress?.();
            }
          }}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
            input: {
              endAdornment: (
                <InputAdornment position="end" className="rms__custom__email__enter__adornment">
                  <IconButton
                    aria-label="submit email"
                    onClick={() => onEnterKeyPress?.()}
                    disabled={isDisabled ?? false}
                    className="rms__custom__email__enter__button"
                    edge="end"
                  >
                    <KeyboardReturnIcon />
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
          className="rms__custom__email__text__field"
        />
      </div>
    </ThemeProvider>
  );
};

export default CustomEmailComponent;
